import CalendarImage from "../../assets/clickthroughAsset/Calendar2.png";

export function SessionGuide({ handleCloseTOSModal } : { handleCloseTOSModal: () => void }) {
  return (
    <div className="relative z-10 w-[80%] mx-[10%] py-20"
        role="dialog"
        aria-modal="true">
        <div className="fixed inset-0 bg-gray-300 bg-opacity-75 transition-all backdrop-blur-sm"></div>
        <div className="flex justify-center px-2 py-12 text-center ">
            <div className="fixed rounded-2xl bg-white text-black text-left shadow-xl transition-all p-4">
                <div className="flex justify-end">
                    <button onClick={handleCloseTOSModal}>
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24"
                            stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                                d="M6 18L18 6M6 6l12 12" />
                        </svg>
                    </button>
                </div>
                <div className="relative">
                    <img src={CalendarImage} alt="Logo" className="w-[80vh] mx-auto mt-4" />
                    <div className="flex justify-center gap-4 mt-4 p-4">
                        <p>These are a list of scheduled sessions, each session can be canceled or reinstated by clicking into it. <br />
                            You will only be billed based on completed sessions.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
  );
}